import { AlertCircle, PlusCircle } from "lucide-react";
import { useAppContext } from "../../../../shared/functions/Context";

interface NoSessionAlertProps {
  onCreateSession: () => void;
}

export default function NoSessionAlert({ onCreateSession }: NoSessionAlertProps) {
  const { store } = useAppContext();
  const permission = store.auth.role; // e.g. "Admin", "HR", "Employee"

  const canCreateSession = permission === "Admin" || permission === "HR";

  return (
 <div className="flex flex-col items-center justify-center p-4 max-w-sm mx-auto border border-dashed border-gray-200 rounded-xl bg-white">
  <AlertCircle className="w-8 h-8 text-orange-400 mb-2" />
  <h2 className="text-base font-semibold text-gray-700">
    No Active Session Found
  </h2>
  <p className="text-xs text-gray-500 mb-3 text-center">
    You don’t have an active rating session yet.{" "}
    {canCreateSession
      ? "Please create a session to get started."
      : "Ask an Admin or HR to create one."}
  </p>

  {/* {canCreateSession && (
    <button
      onClick={onCreateSession}
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-all shadow-sm text-sm"
    >
      <PlusCircle className="w-4 h-4" />
      Create Session
    </button>
  )} */}
</div>


  );
}
